<template>
  <div class="animated fadeIn">
    <div class="clearfix my-5">
      <b-button
        v-if="!isLast()"
        class="float-right"
        variant="primary"
        size="lg"
        :to="path + nextStep()"
        >Next</b-button
      >
      <b-button
        v-if="!isFirst()"
        class="float-right mr-2"
        variant="primary"
        size="lg"
        :to="path + prevStep()"
        >Back</b-button
      >
      <b-button
        class="float-right mr-2"
        variant="danger"
        size="lg"
        @click="$emit('resetForm')"
        >Cancel</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectWizardFooterNav",
  props: ["path", "step"],
  data() {
    return {
      firstStep: 1,
      lastStep: 3
    };
  },
  methods: {
    isFirst() {
      return this.step <= this.firstStep;
    },
    isLast() {
      return this.step >= this.lastStep;
    },
    nextStep() {
      return +this.step + 1 < this.lastStep ? +this.step + 1 : this.lastStep;
    },
    prevStep() {
      return +this.step - 1 > this.firstStep ? +this.step - 1 : this.firstStep;
    }
  }
};
</script>
